import { UserSystemRoleModelPermissionMap } from '../../../../../service/systemRole/entity/actions/UserSystemRoleModelPermissionMap';
import { ContentExportPage } from '../contentTransfer/exportPage/ContentExportPage';
import { ContentImportPage } from '../contentTransfer/importPage/ContentImportPage';
import { ISettingsItem } from '../ISettingsItem';

export const ContentTransferSettingsItem: ISettingsItem = {
  id: 'contentTransfer',
  routers: [
    {
      key: 'importContent',
      path: '/settings/edu/content/import',
      pageTitle: 'contentTransfer.cardTitle',
      component: ContentImportPage,
      allowedPermissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
    },
    {
      key: 'exportContent',
      path: '/settings/edu/content/export',
      pageTitle: 'contentTransfer.cardTitle',
      component: ContentExportPage,
      allowedPermissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
    },
  ],
  settingsItem: {
    key: 'contentTransfer',
    title: 'contentTransfer.cardTitle',
    permissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
    infoText: 'contentTransfer.cardDescription',
    orderIndex: 1200,
    buttons: [
      {
        title: 'contentTransfer.importButton',
        url: '/settings/edu/content/import',
        permissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
      },
      {
        title: 'contentTransfer.exportButton',
        url: '/settings/edu/content/export',
        permissions: [UserSystemRoleModelPermissionMap['global-allow-any']],
      },
    ],
  },
};
